import { useEffect } from 'react';
import { useLocation } from 'react-router';

import WhatsAppLayout from './layout/WhatsAppLayout';
import { useWhatsApp } from '../../hooks/useWhatsApp';

export const WhatsAppScreen = ({ changeCustomStyles, initialStyles, setShowDrawer }) => {
  const location = useLocation();
  useEffect(() => {
    changeCustomStyles({ pr: 0, pl: 0, pb: 0 });
    setShowDrawer(true);
    return () => {
      setShowDrawer(false);
      changeCustomStyles(initialStyles)
    };
  }, [location]);
  return (
    <WhatsAppLayout changeCustomStyles={changeCustomStyles} />
  )
}
